import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

export const useExpandCollapseControlsStyles = makeStyles((theme: Theme) => ({
    expandCollapseContainer: {
        justifyContent: 'flex-end',
        display: 'flex',
        '& button:last-child': {
            marginLeft: theme.spacing(1),
        },
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    expandCollapseButton: {
        border: '1px solid #c9c9c9',
        borderRadius: theme.spacing(2.5),
        color: '#04325B',
        lineHeight: 1.43,
        padding: '5px 10px',
        whiteSpace: 'nowrap',
    },
    expandCollapseButton2: {
        border: '1px solid #C9C9C9',
        borderRadius: pxToRem(100),
        color: '#314959',
        lineHeight: 1.43,
        padding: '5px 10px',
        whiteSpace: 'nowrap',
        height: pxToRem(26),
        width: pxToRem(106),
        fontSize: pxToRem(12),
    },
    buttonLabel: {
        lineHeight: '16px',
    },
}))
